import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { APP_HOME_PATH } from "../../lib/app-paths";

type OpenAppButtonProps = {
  className?: string;
  size?: "default" | "lg";
  label?: string;
  showArrow?: boolean;
};

export const OpenAppButton = ({
  className,
  size = "default",
  label,
  showArrow = false,
}: OpenAppButtonProps) => {
  const { t } = useTranslation();

  return (
    <Link
      to={APP_HOME_PATH}
      className={[
        "pp-open-app",
        size === "lg" ? "pp-open-app--lg" : "",
        className ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label ?? t("landing.openApp")}
      {showArrow ? (
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="pp-open-app-arrow"
        >
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      ) : null}
    </Link>
  );
};
